import React, { Component } from 'react'

export default class SideMenuItem extends Component {
  render() {
    return (
      <a><i style={{ color: '#DFEFEE' }} className={ this.props.classNames }></i> <span style={{ color: '#DFEFEE' }} className="hidden-sm">{ this.props.name }</span> <span className="fa fa-chevron-right"></span></a>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/sidemenuitem.js